"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ahooks_1 = require("ahooks");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var card_items_1 = require("../card-items");
function CardParam(props) {
    var className = props.className, style = props.style, title = props.title, subTitle = props.subTitle, link = props.link, contentTitle = props.contentTitle, detail = props.detail, layout = props.layout, list = props.list, checkList = props.checkList, tagTxt = props.tagTxt, tagColor = props.tagColor, isCoupon = props.isCoupon, backgroundImage = props.backgroundImage, buttonText = props.buttonText, buttonExtendProps = props.buttonExtendProps, linkExtendProps = props.linkExtendProps, onClick = props.onClick;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var _a = (0, react_1.useState)(false), hover = _a[0], setHover = _a[1];
    var ref = (0, react_1.useRef)(null);
    var size = (0, ahooks_1.useSize)(ref);
    var imageStyle = backgroundImage ? { backgroundImage: "url(".concat(backgroundImage, ")") } : {};
    return (react_1.default.createElement("section", { ref: ref, style: style, className: (0, classnames_1.default)("".concat(classPrefix, "-card"), "".concat(classPrefix, "-card-param"), {
            'card-large': size && (size === null || size === void 0 ? void 0 : size.width) > 400,
        }, className), onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } },
        react_1.default.createElement(card_items_1.Tag, { tagTxt: tagTxt, tagColor: tagColor }),
        react_1.default.createElement(card_items_1.Header, { title: title, subTitle: subTitle, isLink: !!link, link: link, isCoupon: isCoupon, extendProps: linkExtendProps }),
        react_1.default.createElement(card_items_1.Snap, { isCoupon: isCoupon }),
        react_1.default.createElement("div", { style: imageStyle, className: "card-bottom" },
            react_1.default.createElement("div", { className: "card-content" },
                react_1.default.createElement("h1", { className: "content-title" }, contentTitle),
                react_1.default.createElement(card_items_1.ContentLayout, { layout: layout, list: list, checkList: checkList, isHover: hover }),
                react_1.default.createElement("p", { className: "content-doc", dangerouslySetInnerHTML: { __html: detail || '' } })),
            react_1.default.createElement("button", __assign({ onClick: onClick }, buttonExtendProps, { className: "card-button" }), buttonText))));
}
exports.default = CardParam;
//# sourceMappingURL=CardParam.js.map